import Swiper from 'swiper/bundle';

const MediaTextarea = () => {
  const sliders = document.querySelectorAll('.media-textarea__swiper');

  if (!sliders.length) return;

  sliders.forEach((slider) => {
    if (!(slider instanceof Element)) return;

    const swiperWrapper = slider.querySelector('.media-textarea__swiper-wrapper');

    if (!swiperWrapper) return;

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      pagination: {
        el: slider.querySelector('.media-textarea__pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector('.media-textarea__nav--next'),
        prevEl: slider.querySelector('.media-textarea__nav--prev'),
      },
    });
  });
};

export default MediaTextarea;
